import { useState } from "react";
import DomainEditor from "./domaineditor";
import { genId } from "../../utils/draftutils";
import { dominiValidi } from "../../utils/gerarchiautils";

export default function RootStep({ hasRadice, onCreated, onValidateName }) {
  const [nome, setNome] = useState("");
  const [nomeValidato, setNomeValidato] = useState(false);
  const [campo, setCampo] = useState("");
  const [tipoFigli, setTipoFigli] = useState("foglia");
  const [dominio, setDominio] = useState([{ valore: "", descrizione: "" }]);

  const [errore, setErrore] = useState("");
  const [loading, setLoading] = useState(false);

  const validaNome = async (e) => {
    e.preventDefault();
    setErrore("");
    const nomeTrim = nome.trim();
    if (!nomeTrim) return setErrore("Inserisci un nome.");
    if (hasRadice) return setErrore("Esiste già una radice nelle bozze.");
    setLoading(true);
    try {
      const ok = await onValidateName(nomeTrim); 
      if (!ok) return setErrore("Questo nome esiste già nel database.");
      setNomeValidato(true);
    } catch (err) {
      setErrore("Problema con il server: " + (err?.message || "sconosciuto"));
    } finally {
      setLoading(false);
    }
  };

  const handleDomChange = (i, field, value) => {
    const nuovo = [...dominio];
    nuovo[i][field] = value;
    setDominio(nuovo);
  };

  const creaRadice = (e) => {
    e.preventDefault();
    setErrore("");

    if (!campo.trim()) return setErrore("Inserisci il campo della nonfoglia.");
    const { ok, rows } = dominiValidi(dominio);
    if (!ok) return setErrore("Completa sia 'Valore dominio' che 'Descrizione' (oppure rimuovi le righe vuote).");

    const radice = {
      tempId: genId(),
      nome: nome.trim(),
      campo: campo.trim(),
      tipoFigli,
      isRadice: true,
      idPadre: null,
      dominioVal: null,
      descrizione: null,
      dominio: rows.map((d) => d.valore),
      descrizioni: rows.map((d) => d.descrizione),
      _createdAt: new Date().toISOString(),
    };

    onCreated(radice);
  };

  if (!nomeValidato) {
    return (
      <form onSubmit={validaNome}>
        {errore && <p style={{ color: "red" }}>{errore}</p>}
        <p style={{ fontStyle: "italic" }}>In questa pagina viene strutturato un albero composto da 2 categorie diverse: raggruppamenti di servizi (non-foglie) e servizi usufruibili (foglie).
          Partendo da una categoria Radice (raggruppamento di servizi), si costruiscono le sue categorie figlie tramite valori di dominio implementati dalla
          categoria padre, fino ad ottenere almeno un servizio usufruibile.</p>
        <label className="form-label mb-2">Inserisci il nome del raggruppamento di servizi Radice:</label>

        <div className="d-flex align-items-center mb-3">
          <input
            type="text"
            className="form-control w-25 me-2"
            placeholder="Nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
          />
          <button
            type="submit"
            className="btn btn-success"
            disabled={loading}
          >
            {loading ? "Verifico..." : "Verifica e Crea"}
          </button>
        </div>

        
      </form>

    );
  }

  return (
    <form onSubmit={creaRadice} style={{ display: "flex", flexDirection: "column", gap: 12, width: 820 }}>
        {errore && <p style={{ color: "red" }}>{errore}</p>}
        <h3>Nome validato: <span className="text-blue-600" style={{ color: "green", fontWeight: "bold" }}>{nome}</span></h3>

        <div className="d-flex align-items-center mb-1">
          <label className="form-label mb-0 me-2">Inserisci il campo della Radice (es. tipologia, materia, ...)</label>
          <input
            type="text"
            className="form-control w-50"
            value={campo}
            onChange={(e) => setCampo(e.target.value)}
            required
          />
        </div>

        <div className="d-flex align-items-center mb-2">
          <label className="form-label mb-0 me-2">Tipo figli:</label>
          <select
            className="form-control w-25"
            value={tipoFigli}
            onChange={(e) => setTipoFigli(e.target.value)}
          >
            <option value="foglia">Servizio</option>
            <option value="nonfoglia">Gruppo di servizi</option>
          </select>
        </div>

        <DomainEditor
          rows={dominio}
          onChange={handleDomChange}
          onAdd={() => setDominio((prev) => [...prev, { valore: "", descrizione: "" }])}
          onRemove={(i) => setDominio((prev) => prev.filter((_, idx) => idx !== i))}
        />

        <div className="mt-3">
          <button type="submit" className="btn btn-success">
            Crea radice (bozza)
          </button>
        </div>
    </form>
  );
}
